const Header = ((($) => {
  let $window;
  let header;
  let headerTop;
  let headerMobileTop;

  function init() {
    $window = $(window);
    header = $('.Header');
    headerTop = $('.Header').offset();
    headerMobileTop = $('.mobile-nav').offset();
    $('.mobile-nav').on('click', function() {
      $(this);
      $('.hamburger').toggleClass('is-active');
      $('body, html').toggleClass('no-scroll');
      $('.Hero').toggleClass('blurred');
      $('.Text-section').toggleClass('blurred');
      $('.Nav').toggleClass('show');
      return false;
    });
    $('.Nav').on('click', 'a', function() {
      $(this);
      $('.hamburger').removeClass('is-active');
      $('body, html').removeClass('no-scroll');
      $('.Hero').removeClass('blurred');
      $('.Text-section').removeClass('blurred');
      $('.Nav').removeClass('show');
      return false;
    });
    _attachEvents();
  }
  function _attachEvents() {
    $window.scroll(_handleWindowScroll);
  }

  function _handleWindowScroll() {
    const scrollTop = $window.scrollTop();
    if (scrollTop >= headerTop.top + 10) {
      header.addClass('fixed');
    }
    else {
      header.removeClass('fixed');
    }
    if($(window).width() <= 768) {
      if (scrollTop >= headerMobileTop.top) {
        $('.mobile-nav').addClass('fixed');
      }
      else {
        $('.mobile-nav').removeClass('fixed');
      }
    }
  }


  return {
    init,
  };

}))(jQuery);

export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js